module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "button is-primary is-pulled-right",
    attrs: {
      "to": {
        name: 'image-create'
      }
    }
  }, [_vm._v("\n        Upload image\n    ")]), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.images,
      "page-length": 50,
      "columns": [{
          name: 'Image',
          prop: 'normal_path',
          type: 'image',
          searchable: false,
          sortable: false
        },
        {
          name: 'Name',
          prop: ['name', 'extension'],
          type: 'text'
        },
        {
          name: 'Normal Size',
          prop: 'normal_size',
          type: 'number',
          filter: 'prettyBytes'
        },
        {
          name: 'Full Size',
          prop: 'full_size',
          type: 'number',
          filter: 'prettyBytes'
        },
        {
          name: 'Created',
          prop: 'created_at',
          type: 'date',
          searchable: false,
          sortable: true,
          filter: ['moment', ['from', 'now']]
        },
        {
          name: 'Updated',
          prop: 'created_at',
          type: 'date',
          searchable: false,
          sortable: true,
          filter: ['moment', ['from', 'now']]
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_Image",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.row.thumbnail_path
          }
        })]
      }
    }, {
      key: "column_Name",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'image',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("\n                " + _vm._s(props.row.name) + "." + _vm._s(props.row.extension) + "\n            ")]), _vm._v(" "), (props.row.related.length > 0) ? _c('div', [_vm._v("\n                Linked to this image:\n                "), _c('br'), _vm._v(" "), _vm._l((props.row.related), function(related) {
          return _c('div', _vm._l((related), function(item, type) {
            return _c('div', [(type === 'product') ? _c('router-link', {
              attrs: {
                "to": {
                  name: 'product',
                  params: {
                    id: item.id
                  }
                }
              }
            }, [_vm._v(_vm._s(item.short_name) + " (product)\n                        ")]) : _vm._e(), _vm._v(" "), (type === 'bundle') ? _c('router-link', {
              attrs: {
                "to": {
                  name: 'bundle',
                  params: {
                    id: item.id
                  }
                }
              }
            }, [_vm._v("BU: " + _vm._s(item.name) + " (bundle)\n                        ")]) : _vm._e(), _vm._v(" "), (type === 'page') ? _c('router-link', {
              attrs: {
                "to": {
                  name: 'page',
                  params: {
                    id: item.id
                  }
                }
              }
            }, [_vm._v("PA: " + _vm._s(item.name) + " (page)\n                        ")]) : _vm._e()], 1)
          }), 0)
        })], 2) : _vm._e()]
      }
    }, {
      key: "controls",
      fn: function(props) {
        return [_c('td', {
          staticClass: "has-text-right",
          attrs: {
            "slot": "controls"
          },
          slot: "controls"
        }, [_c('a', {
          staticClass: "delete",
          on: {
            "click": function($event) {
              return _vm.deleteImage(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fdc79a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/images/ImageList.vue
// module id = 499
// module chunks = 0